import sentryBrowser from './sentry-browser';

// IE11 error with new sentry browser sdk - https://jdog.jira-dev.com/browse/JFP-2406
// remove when IE11 is deprecated and switch to new sentry client
export var installGlobalHandler = function installGlobalHandler(sentryUrl, config, getExtraContext) {
  return sentryBrowser.installGlobalHandler(sentryUrl, config, getExtraContext);
};

// IE11 error with new sentry browser sdk - https://jdog.jira-dev.com/browse/JFP-2406
// remove when IE11 is deprecated and switch to new sentry client
export var captureException = function captureException(location, error) {
  var details = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return sentryBrowser.captureException(location, error, details);
};